<template>

    <div class="container">

        <app-head title="Analytics" />

        <h1 class="page-heading">
            {{ __('Auswertung') }}
        </h1>

        <div class="mb-3">
            <div class="row row-cols-lg-auto gx-3 align-items-center">
                <select-input :label="__('Zeitraum')" v-model="form.type">
                    <option :value="k" v-for="(dateSelectOption, k) in dateSelectOptions">{{ dateSelectOption.label }}</option>
                </select-input>
                <template v-if="form.type === 'custom'">
                    <text-input type="date" label="from" v-model="form.from" />
                    <text-input type="date" label="until" v-model="form.until" />
                </template>
                <select-input label="supplier" v-model="form.supplier_id">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option :value="supplier.id" v-for="supplier in suppliers">{{ supplier.name }}</option>
                </select-input>
            </div>
        </div>

        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
            <div class="col">
                <amount-box title="Bruttoumsatz insgesamt inkl. Versand" :amount="data.total_overall_revenue" growth="0" class=""></amount-box>
            </div>
            <div class="col">
                <card-box title="Bestellungen" class="">
                    <div class="row">
                        <div class="col">
                            <inertia-link :href="route('admin.orders.index', {from: filters.from, until: filters.until, supplier_id: filters.supplier_id})">
                                <span class="display-6">
                                    {{ data.number_of_orders | localizeNumber }}
                                </span>
                                <span>
                                    {{ __('Gesamt') }}
                                </span>
                            </inertia-link>
                        </div>
                        <div class="col">
                            <div>
                                <inertia-link :href="route('admin.orders.index', {from: filters.from, until: filters.until, order_status: 'new', supplier_id: filters.supplier_id})">
                                    <span class="">
                                        {{ data.number_of_new_orders | localizeNumber }}
                                    </span>
                                    <span>
                                        {{ __('New') }}
                                    </span>
                                </inertia-link>
                            </div>
                            <div>
                                <inertia-link :href="route('admin.orders.index', {from: filters.from, until: filters.until, order_status: 'confirmed', supplier_id: filters.supplier_id})">
                                    <span class="">
                                        {{ data.number_of_confirmed_orders | localizeNumber }}
                                    </span>
                                    <span>
                                        {{ __('Confirmed') }}
                                    </span>
                                </inertia-link>
                            </div>
                            <div v-if="data.number_of_completed_orders">
                                <inertia-link :href="route('admin.orders.index', {from: filters.from, until: filters.until, order_status: 'completed', supplier_id: filters.supplier_id})">
                                    <span class="">
                                        {{ data.number_of_completed_orders | localizeNumber }}
                                    </span>
                                    <span>
                                        {{ __('Completed') }}
                                    </span>
                                </inertia-link>
                            </div>
                        </div>
                    </div>
                </card-box>
            </div>
            <div class="col">
                <card-box title="Verkaufte Artikel" class="">
                    <div class="row">
                        <div class="col">
                            <span class="display-6">
                                {{ data.number_of_items | localizeNumber }}
                            </span>
                            <span>
                                {{ __('Gesamt') }}
                            </span>
                        </div>
                        <div class="col">
                            <div>
                                <span class="">
                                    {{ data.number_of_unique_items | localizeNumber }}
                                </span>
                                <span>
                                    {{ __('Verschiedene') }}
                                </span>
                            </div>
                        </div>
                    </div>

                </card-box>
            </div>
            <!--            <div class="col">
                            <number-box title="Retouren" :amount="data.number_of_returned_items" growth="0"></number-box>
                        </div>-->
            <!--            <div class="col">
                            <number-box title="Rabattierte Bestellungen" :amount="data.number_of_discounted_orders" growth="0"></number-box>
                        </div>-->
        </div>

        <hr />

        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
            <div class="col">
                <amount-box title="Nettoumsatz" :amount="data.total_revenue" growth="0"></amount-box>
            </div>
            <div class="col">
                <amount-box title="Bruttoumsatz" :amount="data.total_gross_revenue" growth="0"></amount-box>
            </div>
            <div class="col">
                <amount-box title="Durschnittlicher Bestellwert" :amount="data.average_order_amount" growth="0"></amount-box>
            </div>
            <div class="col">
                <amount-box title="Netto-Rabattsumme" :amount="data.total_discount_amount" growth="0"></amount-box>
            </div>
            <div class="col">
                <amount-box title="Steuer insgesamt" :amount="data.total_tax_amount" growth="0"></amount-box>
            </div>
            <!--            <div class="col">
                            <amount-box title="Bestellungssteuer" amount="0" growth="0"></amount-box>
                        </div>-->
            <!--            <div class="col">
                            <amount-box title="delivery_tax" amount="0" growth="0"></amount-box>
                        </div>-->
            <div class="col">
                <amount-box title="Versand" :amount="data.total_delivery_amount" growth="0"></amount-box>
            </div>
            <!--            <div class="col">
                            <amount-box title="Downloads" :amount="data.number_of_downloads" growth="0"></amount-box>
                        </div>-->
        </div>

        <!--        <hr />@todo
        
                <h2>{{ __('Charts') }}</h2>
                <div class="row row-cols-1 row-cols-md-2 g-4">
                    <div class="col">
                        <chart-box title="Umsatz gesamt" />
                    </div>
                    <div class="col">
                        <chart-box title="Nettoumsatz" />
                    </div>
                    <div class="col">
                        <chart-box title="Bestellungen" />
                    </div>
                    <div class="col">
                        <chart-box title="Durschnittlicher Bestellwert" />
                    </div>
                </div>-->

        <template v-if="$page.props.app.theme == 'dentalink'">

            <hr />

            <h4 class="mb-3">Detailstatistik</h4>

            <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                <div class="col">
                    <number-box title="Anzahl Besucher auf Produktseiten" :amount="120099" growth="0"></number-box>
                </div>
                <div class="col">
                    <number-box title="Anzahl Besucher im Lieferantenprofil" :amount="4501" growth="0"></number-box>
                </div>
                <div class="col">
                    <number-box title="Anzahl Neukunden" :amount="13" growth="0"></number-box>
                </div>
                <div class="col">
                    <number-box title="Anzahl offene Warenkörbe" :amount="3" growth="0"></number-box>
                </div>
                <div class="col">
                    <number-box title="Anzahl abgebrochene Warenkörbe" :amount="1" growth="0"></number-box>
                </div>
                <!--                <div class="col">
                                    <number-box title="Versand" :amount="data.total_delivery_amount" growth="0"></number-box>
                                </div>-->
            </div>

            <hr />

            <h4 class="mb-3">Suchbegriffe</h4>
            <p>Liste der meistgenutzten Suchbegriffe von Mitgliedern im Marktplatz</p>

            <table class="table">
                <tbody>
                    <tr>
                        <td width="30">1.</td>
                        <td width="200">3m</td>
                        <td>45x</td>
                    </tr>
                    <tr>
                        <td>2.</td>
                        <td>klebstoff</td>
                        <td>24x</td>
                    </tr>
                    <tr>
                        <td>3.</td>
                        <td>beschichtungen</td>
                        <td>20x</td>
                    </tr>
                    <tr>
                        <td>4.</td>
                        <td>etiketten</td>
                        <td>12x</td>
                    </tr>
                    <tr>
                        <td>5.</td>
                        <td>folien</td>
                        <td>10x</td>
                    </tr>
                </tbody>
            </table>

        </template>

    </div>

</template>

<script>
    import CardBox from '@/shared/Admin/CardBox';
    import AmountBox from '@/shared/Admin/AmountBox';
    import NumberBox from '@/shared/Admin/NumberBox';
    import ChartBox from '@/shared/Admin/ChartBox';

    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';

    export default {
        props: [
            'data',
            'suppliers',
            'filters',
            'dateSelectOptions',
        ],
        components: {
            CardBox,
            AmountBox,
            NumberBox,
            ChartBox,
            TextInput,
            SelectInput,
        },
        data() {
            return {
                form: {
                    type: this.filters.type,
                    from: this.filters.from,
                    until: this.filters.until,
                    supplier_id: this.filters.supplier_id,
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.analytics.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>